<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import pessoaServico from '~modulos/acessos/servico';
  import projetoServico from '~modulos/projeto/servico';

  export default {
    components: { checkbox },
    props: {
      solicitacao: Object,
      edicao: Boolean,
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        configuracao: this.$storage.configuracao(),
        obrigatorioEndereco: false,
        desabilitarEndereco: false,
      }
    },
    computed: {
      observacaoSolicitacaoContador: function() {
        let quantidadeCaracteres = this.solicitacao.observacaoSolicitacao ? 
          this.solicitacao.observacaoSolicitacao.length : 0;

        return 500 - quantidadeCaracteres;
      },
    },
    methods: {
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolImportacao")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
      getCEP() {
        if (this.carregando) return;

        let textoCEP = this.solicitacao.cepLocalAlocado.replace('-', '').replace('.', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.solicitacao.enderecoLocalAlocado = cepObj.logradouro.substring(0, 100);
              this.solicitacao.bairroLocalAlocado = cepObj.bairro.substring(0, 40);
              this.solicitacao.cidadeLocalAlocado = cepObj.localidade.substring(0, 40);
              this.solicitacao.estadoLocalAlocado = cepObj.uf;
              //this.solicitacao.numeroLocalAlocado = "";
              //this.solicitacao.complementoLocalAlocado = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);
            this.$set(this.solicitacao, 'coordenador', projeto.coordenadorProjeto);
            this.$set(this.solicitacao, 'tituloProjeto', projeto.tituloProjeto);
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function (e) {
          _this.$set(_this.solicitacao, 'idProjeto', this.value);

          _this.setarProjeto(this.value);
        });
      },
    },
    mounted() {
      this.listaDeProjetos();
      this.iniciarSelect2Projeto();
    },
    updated(){
        const _this = this;

        this.$watch('solicitacao.cepLocalAlocado', function () {
            _this.getCEP();
        })
    },
    watch: {

    }
  }
</script>

<template>
  <div>
    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Projeto
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-8">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select id="projeto"
                  class="form-control"
                  v-model="solicitacao.idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
              <option :value="projeto.idProjeto"
                      v-for="(projeto, index) in projetos"
                      :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacao) || projeto.acompanhamentoPendente || projeto.inativoDebito">
                  {{ projeto.nomeProjeto }}

                  <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacao)">
                      (Data limite até: {{ projeto.dataLimiteSolicitacao | formatarData }})
                  </template>

                  <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolicitacao) && !projeto.inativoDebito">
                      (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
                  </template>

                  <template v-if="projeto.inativoDebito">
                      (Projeto bloqueado para solicitações, pois o projeto está inativo para débito)
                  </template>
              </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input type="text"
                 class="form-control"
                 v-model="solicitacao.projeto.nomeProjeto"
                 disabled>
        </div>
      </div>

      <div class="col-sm-4">
          <div class="form-group" :class="{'has-error': errors.has('coordenador')}">
              <label class="control-label" for="coordenador">Coordenador</label>

              <input type="text"
                     class="form-control"
                     id="coordenador"
                     v-model="solicitacao.coordenador"
                     data-vv-as="coordenador"
                     data-vv-name="coordenador">

              <p class="text-danger" v-show="errors.has('area')">{{ errors.first('coordenador') }}</p>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('instituicaosede')}">
          <label class="control-label" for="instituicaosede">Instituição</label>

          <input type="text"
                 class="form-control"
                 id="instituicaosede"
                 v-model="solicitacao.instituicaoSede"
                 data-vv-as="instituicaosede"
                 data-vv-name="instituição"
                 maxlength="150">

          <p class="text-danger" v-show="errors.has('area')">{{ errors.first('instituicaosede') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('cnpjexecutora')}">
          <label class="control-label" for="cnpjexecutora">CNPJ</label>

          <input type="text"
                 class="form-control"
                 id="cnpjexecutora"
                 v-mascara="'cnpj'"
                 v-model="solicitacao.cnpjExecutora"
                 data-vv-as="cnpj"
                 data-vv-name="cnpjexecutora"
                 v-validate="'cnpj'">

          <p class="text-danger" v-show="errors.has('cnpjexecutora')">{{ errors.first('cnpjexecutora') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group" :class="{'has-error': errors.has('credenciamentocnpq')}">
          <label class="control-label" for="credenciamentocnpq">Credenciamento CNPQ</label>

          <input type="text"
                 class="form-control"
                 id="credenciamentocnpq"
                 v-model="solicitacao.credenciamentoCNPQ"
                 data-vv-as="credenciamentocnpq"
                 data-vv-name="credenciamento CNPQ"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('credenciamentocnpq')">{{ errors.first('credenciamentocnpq') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('area')}">
          <label class="control-label" for="area">Departamento</label>

          <input type="text"
                 class="form-control"
                 id="area"
                 v-model="solicitacao.area"
                 data-vv-as="area"
                 data-vv-name="departamento"
                 maxlength="150">

          <p class="text-danger" v-show="errors.has('area')">{{ errors.first('area') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('subarea')}">
          <label class="control-label" for="subarea">Laboratório</label>

          <input type="text"
                 class="form-control"
                 id="subarea"
                 v-model="solicitacao.subArea"
                 data-vv-as="subarea"
                 data-vv-name="laboratório"
                 maxlength="150">

          <p class="text-danger" v-show="errors.has('subarea')">{{ errors.first('subarea') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="tituloprojeto">
            Título do Projeto
          </label>

          <textarea class="form-control"
                    id="tituloprojeto"
                    v-model="solicitacao.tituloProjeto"
                    maxlength="250">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="descricaoImportacaoProjeto">
            Descrição do projeto
          </label>

          <textarea class="form-control"
                    id="descricaoImportacaoProjeto"
                    v-model="solicitacao.descricaoImportacaoProjeto">
      </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="descricaoImportacaoFinanciador">
            Objetivo
          </label>

          <textarea class="form-control"
                    id="descricaoImportacaoFinanciador"
                    v-model="solicitacao.descricaoImportacaoFinanciador">
          </textarea>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Dados Local de Entrega e de doação de Bens e Equipamentos
        </button>
      </div>
    </div>

    <div class="row">

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('ceplocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="cep-local-alocado">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep-local-alocado"
                 data-vv-name="ceplocalAlocado"
                 data-vv-as="cep"
                 :disabled="desabilitarEndereco"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 v-model="solicitacao.cepLocalAlocado"
                 v-mascara="'cep'">

          <p class="text-danger" v-show="errors.has('ceplocalAlocado')">{{ errors.first('ceplocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('enderecolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="endereco-local-alocado">Endereço</label>

          <input type="text"
                 class="form-control"
                 id="endereco-local-alocado"
                 v-model="solicitacao.enderecoLocalAlocado"
                 data-vv-name="enderecolocalAlocado"
                 :disabled="desabilitarEndereco"
                 data-vv-as="endereço"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('enderecolocalAlocado')">{{ errors.first('enderecolocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('numerolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="numero-local-alocado">Número</label>

          <input type="text"
                 class="form-control"
                 id="numero-local-alocado"
                 v-model="solicitacao.numeroLocalAlocado"
                 data-vv-name="numerolocalAlocado"
                 data-vv-as="número"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numerolocalAlocado')">{{ errors.first('numerolocalAlocado') }}</p>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="complemento-local-alocado">Complemento</label>

          <input type="text"
                 class="form-control"
                 id="complemento-local-alocado"
                 v-model="solicitacao.complementoLocalAlocado"
                 data-vv-name="complementolocalAlocado"
                 data-vv-as="complemento"
                 maxlength="80">

        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('bairrolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="bairro-local-alocado">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro-local-alocado"
                 v-model="solicitacao.bairroLocalAlocado"
                 data-vv-name="bairrolocalAlocado"
                 :disabled="desabilitarEndereco"
                 data-vv-as="bairro"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('bairrolocalAlocado')">{{ errors.first('bairrolocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-4">

        <div class="form-group" :class="{'has-error': errors.has('cidadelocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="cidade-local-alocado">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade-local-alocado"
                 v-model="solicitacao.cidadeLocalAlocado"
                 data-vv-name="cidadelocalAlocado"
                 :disabled="desabilitarEndereco"
                 data-vv-as="cidade"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('cidadelocalAlocado')">{{ errors.first('cidadelocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group" :class="{'has-error': errors.has('estadolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="estado-local-alocado">Estado</label>

          <select class="form-control"
                  id="estado-local-alocado"
                  data-vv-name="estadolocalAlocado"
                  :disabled="desabilitarEndereco"
                  data-vv-as="estado"
                  v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                  v-model="solicitacao.estadoLocalAlocado">
            <option value="" selected>Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('estadolocalAlocado')">{{ errors.first('estadolocalAlocado') }}</p>
        </div>
      </div>
    </div>

    <p>
      <b>
        Informe os dados da pessoa que devemos contatar, caso haja dúvidas ao
        processarmos essa solicitação, ou marque o campo abaixo.
      </b>
    </p>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-xs btn-success" @click="preencherDadosContato">
            <i class="fa fa-user-circle"></i> Clique aqui para preencher com os seus dados
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('nomeSolicitante')}">
          <label class="control-label" for="nome-solicitante">Nome solicitante</label>

          <input type="text"
                 class="form-control"
                 id="nome-solicitante"
                 data-vv-name="nomeSolicitante"
                 v-model="solicitacao.nomeSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="nome"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeSolicitante')">{{ errors.first('nomeSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('emailSolicitante')}">
          <label class="control-label" for="email-solicitante">E-mail solicitante</label>

          <input type="text"
                 class="form-control"
                 id="email-solicitante"
                 data-vv-name="emailSolicitante"
                 v-model="solicitacao.emailSolicitante"
                 v-validate="`required|emailcomposto`"
                 data-vv-as="e-mail"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailSolicitante')">{{ errors.first('emailSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneSolicitante')}">
          <label class="control-label" for="telefone-solicitante">Telefone solicitante</label>

          <input type="text"
                 class="form-control"
                 id="telefone-solicitante"
                 data-vv-name="telefoneSolicitante"
                 v-model="solicitacao.telefoneSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="telefone"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefoneSolicitante')">{{ errors.first('telefoneSolicitante') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/compartilhado/FormDadosSolicitacao.vue